import styled from "styled-components";
import theme from "../../../../Styles/theme";

export const Container = styled.div`
display:flex;
align-items: center;
justify-content:center;
flex-direction: column;
`;

export const Button = styled.button`
margin-top:2vh;
color:${theme.colors.light};
background-color: ${theme.colors.darkGrey};
border-radius: 0.25rem;
font-size:max(8px, 1vw);
padding: 1vh 2vw;
`;